/**
 * Named forecast presets for the settings bar. `ScenarioSettings.market` / `.costs` stay signed
 * percentages on the wire — these tables are only the label layer on top of them.
 */
export const FORECAST_PRESET = {
  OPTIMISTIC: "optimistic",
  NEUTRAL: "neutral",
  PESSIMISTIC: "pessimistic",
} as const;

export type ForecastPreset = (typeof FORECAST_PRESET)[keyof typeof FORECAST_PRESET];

/** Display order in the dropdown. */
export const FORECAST_PRESET_ORDER: ForecastPreset[] = [FORECAST_PRESET.OPTIMISTIC, FORECAST_PRESET.NEUTRAL, FORECAST_PRESET.PESSIMISTIC];

/** Selected value when the stored percentage matches no preset (set via the project settings drawer). */
export const FORECAST_PRESET_CUSTOM = "custom";

export const FORECAST_TREND_PCT = 20;

/** Output prices: optimistic means prices rise, so the sign is positive. */
export const OUTPUT_COST_PRESET_PCT: Record<ForecastPreset, number> = {
  [FORECAST_PRESET.OPTIMISTIC]: FORECAST_TREND_PCT,
  [FORECAST_PRESET.NEUTRAL]: 0,
  [FORECAST_PRESET.PESSIMISTIC]: -FORECAST_TREND_PCT,
};

/** Input costs: optimistic means costs fall, so the sign is inverted against output prices. */
export const INPUT_COST_PRESET_PCT: Record<ForecastPreset, number> = {
  [FORECAST_PRESET.OPTIMISTIC]: -FORECAST_TREND_PCT,
  [FORECAST_PRESET.NEUTRAL]: 0,
  [FORECAST_PRESET.PESSIMISTIC]: FORECAST_TREND_PCT,
};
